import React from 'react'
import {Button} from '@mui/material'
import {styled} from '@mui/system'
import {colors} from '@/constants'

interface OutlinedButtonProps {
  bgColor?: string
  textColor?: string
  fontSize?: string
  fontWeight?: string
  padding?: string
  width?: string
  height?: string
  hoverTextColor?: string
  hoverBgColor?: string
  borderRadius?: string
  boxShadow?: string
  boxShadowHover?: string
  flex?: string
  maxWidth?: string
  bord?: string
  background?: string
  gap?: string
  maxHeight?: string
}

const _HoverButton = styled(Button, {
  shouldForwardProp: (prop) =>
    prop !== 'bgColor' &&
    prop !== 'textColor' &&
    prop !== 'fontSize' &&
    prop !== 'fontWeight' &&
    prop !== 'padding' &&
    prop !== 'width' &&
    prop !== 'height' &&
    prop !== 'gap' &&
    prop !== 'hoverTextColor' &&
    prop !== 'hoverBgColor' &&
    prop !== 'borderRadius' &&
    prop !== 'boxShadow' &&
    prop !== 'boxShadowHover' &&
    prop !== 'flex' &&
    prop !== 'background' &&
    prop !== 'borderColor' &&
    prop !== 'maxHeight' &&
    prop !== 'maxWidth',
})<OutlinedButtonProps>`
  color: ${(props) => (props.textColor ? props.textColor : 'white')};
  gap: ${(props) => (props.gap ? props.gap : '0')};
  background-color: ${(props) => props.bgColor};
  border-radius: ${(props) =>
    props.borderRadius ? props.borderRadius : '50px'};
  text-transform: none;
  background: ${(props) =>
    props.background ? props.background : colors.brown};
  font-size: ${(props) => (props.fontSize ? props.fontSize : '24px')};
  font-weight: ${(props) => (props.fontWeight ? props.fontWeight : '600')};
  box-shadow: ${(props) =>
    props.boxShadow ? props.boxShadow : '0px 0px 10px 0px #FFF17233'};
  padding: ${(props) => props.padding};
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  max-height: ${(props) => props.maxHeight};
  min-width: 10px;
  box-sizing: border-box;
  flex: ${(props) => props.flex};
  border: ${(props) =>
    props.bord ? props.bord : '1px solid ' + colors.lightBrown};
  max-width: ${(props) => props.maxWidth};
  &:hover {
    background: ${(props) =>
      props.hoverBgColor ? props.hoverBgColor : colors.brown2};
    color: ${(props) =>
      props.hoverTextColor ? props.hoverTextColor : colors.white};
    box-shadow: ${(props) =>
      props.boxShadowHover
        ? props.boxShadowHover
        : '0px 0px 10px 0px #FFF17266 inset'};
  }
  &:disabled {
    background: ${colors.brown};
    color: ${colors.gray};
    border: 1px solid ${colors.gray + 66};
    box-shadow: 0px 0px 10px 0px #fff17233;
  }
`

// eslint-disable-next-line react/display-name
const HoverButton = React.forwardRef(
  (props: any, ref: React.ForwardedRef<HTMLButtonElement>) => (
    <_HoverButton variant="contained" ref={ref} {...props}>
      {props.children}
    </_HoverButton>
  )
)

// eslint-disable-next-line react/display-name
// const HoverButton = React.forwardRef(
//   (props: any, ref: ForwardedRef<HTMLButtonElement>) => (
//     <_HoverButton {...props} ref={ref}>
//       {/* eslint-disable-next-line react/prop-types */}
//       {props.children}
//     </_HoverButton>
//   ),
// )
export default HoverButton
